<div class="intro">
  <div class="introducing"><div>Introducing</div><div>TimeWarp!</div></div>
  <div class="stake"><div>Stake your TIME and</div><div>earn ongoing rewards</div></div>
  <img class="illustration" src="/static/images/landing/illustration-1x.png" srcset="/static/images/landing/illustration-2x.png 2x">
</div>
